import React from 'react'
import { Link } from 'react-router-dom'
import { useState } from 'react';
import { IoIosArrowForward } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BiBorderRadius } from 'react-icons/bi';

function WhatsAppWidget() {
    const [chatbuttoncolor, setchatbuttonColor] = useState("#2f7c2b");
    const [chatbuttonText, setchatbuttonText] = useState('Chat with us')
    const [chatbuttonMarginbottom, setchatbuttonMarginbottom] = useState(30)
    const [chatbuttonMarginleft, setchatbuttonMarginleft] = useState(100)
    const [chatbuttonMarginright, setchatbuttonMarginright] = useState(25)
    const [chatbuttonradius, setchatbuttonradius] = useState(25)
    const [chatbuttondefaultMessage, setchatbuttondefaultMessage] = useState('Hi')
    const [chatbuttonPosition, setchatbuttonPosition] = useState('right')
    const [showchatCard, setshowchatCard] = useState(false)

    const [UserName, setUserName] = useState('SmartTech')
    const [Subtitle, setSubtitle] = useState('Online')
    const [BrandColor, setBrandColor] = useState('#0a5f54')
    const [ImageUrl, setImageUrl] = useState('')
    const [WidgetText, setWidgetText] = useState('Chat Now')
    const [OnscreenMessage, setOnscreenMessage] = useState('Hi, How can I help you?')
    const [widgetdefault, setwidgetdefault] = useState("yes");

    return (
        <>
            <div className=' dark:bg-[#121519]   pl-4 pr-4 min-h-screen relative'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-2 w-[100%]  '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff] flex items-center'>  <Link to='/Automation'><FaArrowLeftLong /> </Link>   WhatsApp Widgets</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'> <Link to='/'>Home</Link>  <IoIosArrowForward />  <span>WhatsApp </span> <IoIosArrowForward /><span>WhatsApp Widgets</span>
                    </div>
                </div>
                <div className="shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] rounded-lg p-5 bg-white w-[100%] mt-4">
                    <h2 className='text-[#000] text-[22px] font-semibold '>Domain</h2>
                    <p className='text-[#576071] text-[14px]'>The domain is required. If left empty, requests will be unauthorized.</p>
                    <input type="text" className='border border-[#d4cfcf] text-[#454546] font-medium bg-white
                  w-[100%] outline-none p-1 rounded-lg mt-2
                  '
                        placeholder='example.com' />
                </div>
                <div className="shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] rounded-lg p-5 bg-white w-[100%] mt-4">
                    <h2 className='text-[#000] text-[22px] font-semibold '>WhatsApp Button
                    </h2>
                    <p className='text-[#576071] text-[14px]'>You can customize the WhatsApp button according to the URL of your website.</p>

                    <div className='w-[100%] flex flex-wrap justify-between '>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>WhatsApp Channel</label>
                            <select name="" id=""
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'>
                                <option value="">Select Channel</option>
                                <option value="919216058712">919216058712</option>
                            </select>
                        </div>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Button Background</label>
                            <input type="color" name="name" id=""
                                value={chatbuttoncolor}
                                onChange={(e) => setchatbuttonColor(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>CTA Text</label>
                            <input type="text" name="name" id=""
                                value={chatbuttonText}
                                onChange={(e) => setchatbuttonText(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                                maxLength={30}
                            />
                        </div>
                        <div className='sm:w-[24%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Margin Bottom</label>
                            <input type="number" name="name" id=""
                                value={chatbuttonMarginbottom}
                                onChange={(e) => setchatbuttonMarginbottom(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[24%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Margin Left</label>
                            <input type="number" name="name" id=""
                                value={chatbuttonMarginleft}
                                onChange={(e) => setchatbuttonMarginleft(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[24%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Margin Right</label>
                            <input type="number" name="name" id=""
                                value={chatbuttonMarginright}
                                onChange={(e) => setchatbuttonMarginright(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[24%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Border Radius</label>
                            <input type="number" name="name" id=""
                                value={chatbuttonradius}
                                onChange={(e) => setchatbuttonradius(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[48%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Default Message</label>
                            <textarea type="text" name="name" id=""
                                value={chatbuttondefaultMessage}
                                onChange={(e) => setchatbuttondefaultMessage(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>

                    </div>
                    <div>
                        <p className='text-[#000] text-[12px] font-semibold dark:text-[#fff] mt-4'>Position</p>
                        <div className='flex felx-wrap gap-2'>
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="position"
                                    value="right"
                                    checked={chatbuttonPosition === "right"}
                                    onChange={(e) => setchatbuttonPosition(e.target.value)}
                                />
                                <span className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Bottom-Right</span>
                            </label>

                            {/* Bottom Left */}
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="position"
                                    value="left"
                                    checked={chatbuttonPosition === "left"}
                                    onChange={(e) => setchatbuttonPosition(e.target.value)}
                                />
                                <span className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Bottom-Left</span>
                            </label>
                        </div>

                    </div>

                </div>
                <button
                    onClick={() => {
                        setshowchatCard(!showchatCard)
                    }}
                    style={{
                        backgroundColor: chatbuttoncolor,
                        borderRadius: `${chatbuttonradius}px`,
                        bottom: `${chatbuttonMarginbottom}px`,
                        ...(chatbuttonPosition === "right"
                            ? { right: `${chatbuttonMarginright}px` }
                            : { left: `${chatbuttonMarginleft}px` })
                    }}
                    className={` w-[120px] py-2 px-3  fixed  text-[#fff] font-semibold text-[16px]`}>
                    {chatbuttonText}
                </button>

                {showchatCard &&
                    <div className="fixed right-[40px] bottom-[100px] w-[280px] bg-white rounded-lg shadow-lg overflow-hidden">

                        <div
                            style={{
                                backgroundColor: BrandColor
                            }}

                            className="flex items-center gap-3 p-3 text-white relative ">
                            <span
                                onClick={() => {
                                    setshowchatCard(!showchatCard)
                                }}
                                class="absolute right-3 top-1 cursor-pointer text-lg">×</span>

                            <img
                                src={ImageUrl}
                                alt="avatar"
                                class="w-10 h-10 rounded-full"
                            />

                            <div>
                                <h6 className="m-0 font-semibold">{UserName}</h6>
                                <p className="m-0 text-[12px] opacity-80">{Subtitle}</p>
                            </div>
                        </div>

                        <div className="p-3 bg-[#f5f5f5]">
                            <p
                                style={{ whiteSpace: "pre-line" }}
                                className="bg-white px-3 py-2 rounded-md text-[14px] shadow-sm  break-words text-wrap">
                                {OnscreenMessage}
                            </p>
                        </div>

                        <div className="p-3 flex justify-center">
                            <button className="bg-[#2f7c2b] text-white px-4 py-2 rounded-[25px] font-semibold w-[100%]">
                                {WidgetText}
                            </button>
                        </div>

                    </div>
                }

                <div className="shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] rounded-lg p-5 bg-white w-[100%] mt-4">
                    <h2 className='text-[#000] text-[22px] font-semibold '>WhatsApp Widget
                    </h2>
                    <p className='text-[#576071] text-[14px]'>YYou can customize the WhatsApp Widget according to the URL of your website.

                    </p>

                    <div className='w-[100%] flex flex-wrap gap-4 '>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>User Name</label>

                            <input type="text" name="name" id=""
                                value={UserName}
                                onChange={(e) => setUserName(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Subtitle</label>

                            <input type="text" name="name" id=""
                                value={Subtitle}
                                onChange={(e) => setSubtitle(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Brand Color</label>
                            <input type="color" name="name" id=""
                                value={BrandColor}
                                onChange={(e) => setBrandColor(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Brand Image URL</label>

                            <input type="text" name="name" id=""
                                value={ImageUrl}
                                onChange={(e) => setImageUrl(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>
                        <div className='sm:w-[32%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'> Widget CTA Text</label>
                            <input type="text" name="name" id=""
                                value={WidgetText}
                                onChange={(e) => setWidgetText(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                                maxLength={30}
                            />
                        </div>
                        <div className='sm:w-[48%]  w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>On-screen Message</label>
                            <textarea type="text" name="name" id=""
                                value={OnscreenMessage}
                                onChange={(e) => setOnscreenMessage(e.target.value)}
                                className={`text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]`}
                            />
                        </div>

                    </div>
                    <div>
                        <p className='text-[#000] text-[12px] font-semibold dark:text-[#fff] mt-4'>Open widget by default?</p>
                        <div className="flex flex-wrap gap-2">
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="widget"
                                    value="yes"
                                    checked={widgetdefault === "yes"}
                                    onChange={(e) => setwidgetdefault(e.target.value)}
                                />
                                <span>Yes</span>
                            </label>

                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="widget"
                                    value="no"
                                    checked={widgetdefault === "no"}
                                    onChange={(e) => setwidgetdefault(e.target.value)}
                                />
                                <span>No</span>
                            </label>
                        </div>
                    </div>

                </div>
                <div className='w-[100%] flex justify-center items-center mt-6'>
                    <button className='bg-[#3fca90] hover:bg-[#31b07b] text-[#fff] py-1 px-10 rounded-md text-[12px] font-bold'>Generate Snippet</button>
                </div>
            </div>
        </>
    )
}

export default WhatsAppWidget
